import mailerApi from "../api/mailer"

export default async function sendEmail(body){
    const token = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJjbGllbnRJZCI6Imh1ZGRsZSIsImNsaWVudFNlY3JldCI6Imh1ZGRsZVNlY3JldCIsImlhdCI6MTYyMzE5MDkwN30.6EZK1_nF934wXz3PTpGOnI1lZRzcq4vyAxXbsXtxuJk"
    const headers = { Authorization: `Bearer ${token}` }
    try {
        let sendEmailReq = await mailerApi.post(`/emails`, body, { headers })
        // console.log("sendEmail response: ", sendEmailReq)
    } catch (error) {
        //TODO: make a error message showing up instead console.log error
        // console.error("error trying to send mail: ", error)
    }
    
}
